<script>
  export { className as class }

  let className = ""
</script>

<div class="[ inline-block align-bottom text-left transform sm:align-middle ] {className}">
  <slot />
</div>
